import { format } from '@formkit/tempo';
import { PROMOTION_TYPES } from '@resources/js/components/promotion/config';
import sendClickunderStats from '@resources/js/components/clickunderStats';
import { setCookie } from '@resources/js/helpers/cookies';
const FORMAT_DATE = 'YYYY-MM-DD';
const TYPE = 'calendar-form';
const handleCalendarFormSubmit = ({ partnerType = 'bcom', formData, customBeforeRedirectCallback, customRedirectCallback, }) => {
    var _a;
    const url = ((_a = PROMOTION_TYPES[partnerType]) !== null && _a !== void 0 ? _a : PROMOTION_TYPES.bcom).generateLink({
        type: TYPE,
        dates: {
            checkIn: format(formData.checkIn, FORMAT_DATE),
            checkOut: format(formData.checkOut, FORMAT_DATE),
        },
        adultsCount: formData.adultsCount,
        childrenCount: formData.childrenCount,
        childrenAges: formData.children.map(child => child.age),
    });
    // завжди відправляємо івент клікандера
    handleSendClickunderStats(url);
    // додаткова дія перед редіректом, стандартний клікандер не замінює
    customBeforeRedirectCallback === null || customBeforeRedirectCallback === void 0 ? void 0 : customBeforeRedirectCallback({ url });
    setCookie('clkndr', 1);
    if (customRedirectCallback)
        customRedirectCallback(url);
    else
        window.open(url, '_blank');
};
const handleSendClickunderStats = (url) => {
    sendClickunderStats({ type: TYPE, partnerUrl: url });
};
export default handleCalendarFormSubmit;
